<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-row>


            <v-col :cols="customBreakpoint">
                <v-card outlined class="card">
                    <v-card-title>
                        Default Results View
                        <v-icon class="setting-scope-icon">mdi-account</v-icon>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">
                        <v-row>
                            <v-col cols="12">
                                <span>Density</span>
                                <v-select v-model="$props.reportSettings.defaultDensity" :items="[{text: 'Comfortable', value: 'comfortable'}, {text: 'Compact', value: 'compact'}]" color="#c42111" />
                            </v-col>
                            <!-- <v-col cols="12">
                                <span>Autosize Column Width</span>
                                <v-switch v-model="$props.reportSettings.autosizeColumns" label="Off/On" color="#c42111" />
                            </v-col> -->

                            <v-col cols="12">
                                <span>Chart Default All Columns</span>
                                <v-switch v-model="$props.reportSettings.defaultChartAllColumns" color="#c42111" label="Off/On" />
                            </v-col>
                            <v-col cols="12">
                                <span>Convert to Percent Values for CSV/Excel Export</span>
                                <v-switch v-model="$props.reportSettings.convertToPercentForExport" color="#c42111" label="Off/On" />
                            </v-col>

                            <v-col cols="12">
                                <span style="display: block;">Default Chart Colors</span>

                                <div class="chart-colors-contaner">

                                    <div class="chart-colors-picker-container">
                                        <v-color-picker class="chart-colors-picker" width="500" v-model="selectedChartColor" mode="hexa" hide-mode-switch light></v-color-picker>
                                        <v-btn class="chart-color-add-button" color="#c42111" @click="addColor">Add Color</v-btn>
                                    </div>

                                    <v-simple-table class="chart-colors-table" light height="335" fixed-header>
                                        <thead>
                                            <tr>
                                                <th class="text-left">#</th>
                                                <th class="text-left">Color</th>
                                                <th class="text-left">HEX</th>
                                                <th class="text-left">RGB</th>
                                                <th class="text-left">HSL</th>
                                                <th class="text-center"></th>
                                            </tr>
                                        </thead>
                                        <draggable v-model="$props.reportSettings.chartColors" tag="tbody">
                                            <tr v-for="(chartColor, idx) in $props.reportSettings.chartColors" :key="chartColor">
                                                <td>{{ idx + 1 }}</td>
                                                <td>
                                                    <div class="color-box" :style="{'background-color': chartColor}"></div>
                                                </td>
                                                <td>{{ chartColor }}</td>
                                                <td>{{ getRGB(chartColor) }}</td>
                                                <td>{{ getHSL(chartColor) }}</td>
                                                <td><v-btn icon @click="deleteColor(idx)"><v-icon>mdi-delete</v-icon></v-btn></td>
                                            </tr>
                                        </draggable>
                                    </v-simple-table>
                                </div>
                            </v-col>

                            <v-col cols="12">
                                <span>Allow right-click to edit chart colors</span>
                                <v-switch v-model="$props.reportSettings.allowRightClickEditChartColors" color="#c42111" label="Off/On" />
                            </v-col>
                            <v-col cols="12">
                                <span>All network elements use the same color per metric</span>
                                <v-switch v-model="$props.reportSettings.metricCommonColor" color="#c42111" label="Off/On" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>


        </v-row>
    </v-container>
</template>

<script>
import draggable from 'vuedraggable';
export default {
    name: 'Reports',
    props: ['reportSettings'],
    components: {
        draggable
    },
    data: () => ({
        chartColors: ["#f7a35c", "#7cb5ec", "#278713", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
        selectedChartColor: "#ffffff"
    }),

    computed: {
        customBreakpoint() {
            return this.$vuetify.breakpoint.width > 1920 ? 6 : 12;
        }
    },

    methods: {
        getRGB: function(hex) {
            let rgb = TELSA.convertHexColorToRGB(hex);
            return `(${rgb.r}, ${rgb.g}, ${rgb.b})`;
        },

        getHSL: function(hex) {
            let hsl = TELSA.convertHexColorToHSL(hex);
            return `(${hsl.h}, ${hsl.s}%, ${hsl.l}%)`;
        },

        addColor: function() {
            if(!this.$props.reportSettings.chartColors.includes(this.selectedChartColor)) {
                this.$props.reportSettings.chartColors.push(this.selectedChartColor);
            }
        },

        deleteColor: function(idx) {
            this.$props.reportSettings.chartColors.splice(idx, 1);
        }
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        /* max-height: calc(100vh - 224px); */
        max-height: calc(100vh - 200px);
        position: relative;
    }

    .card-body {
        overflow-y: auto;
        max-height: calc(100vh - 310px);
        max-height: calc(100vh - 270px);
        position: relative;
    }

    .chart-colors-contaner {
        display: block;
        margin-top: 10px;
    }

    .chart-colors-picker-container {
        display: inline-block;
        width: 500;
        margin-right: 10px;
        float: left;
    }

    .chart-colors-picker {
        display: block;
    }

    .chart-color-add-button {
        display: block;
        margin-top: 5px;
        width: 100%;
    }

    .chart-colors-table {
        display: inline-block;
        width: calc(100% - 510px);
        border-radius: 4px;
    }

    .chart-colors-table .color-box {
        height: 20px;
        width: 20px;
        border: #000000 solid 1px;
    }

</style>
